import { AutoFixHigh as AutoFixHighIcon, PermMedia as PermMediaIcon } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Grid, Stack, TextareaAutosize } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const ImageGenerationFooterComponent = ({ prompt, isGeneratingAIPrompt, isGeneratingPost, handleFields }) => {
  const theme = useTheme();
  return (
    <>
      <Stack direction="row" alignItems="flex-start" spacing={2} style={{ width: '100%' }}>
        <div style={{ position: 'relative', width: '100%' }}>
          <TextareaAutosize
            minRows={4}
            maxRows={8}
            placeholder="Write a prompt"
            value={prompt}
            onChange={(e) => handleFields(e.target.value, 'prompt')}
            style={{
              width: '100%',
              padding: '12px',
              paddingBottom: '48px', 
              borderRadius: '8px',
              border: '1px solid #ccc',
              backgroundColor: '#f9f9f9',
              fontSize: '16px',
              resize: 'none',
              fontFamily: 'Public sans, sans-serif',
              outline: 'none',
              transition: 'box-shadow 0.3s ease',
              boxShadow: prompt?.trim() ? `0 0 8px 2px ${theme.palette.primary.main}` : 'none',
            }}
          />
          <LoadingButton
            variant="outlined"
            loading={isGeneratingAIPrompt}
            endIcon={<AutoFixHighIcon />}
            onClick={() => handleFields(true, 'generatingaiprompt')}
            style={{
              position: 'absolute',
              bottom: '12px',
              left: '12px',
              textTransform: 'none',
              padding: '4px 12px',
              fontSize: '14px',
              zIndex: 2,
            }}
          >
            Enhance
          </LoadingButton>
        </div>
      </Stack>

      <Stack spacing={1} style={{ marginTop: 10 }}>
        <Grid container spacing={2} alignItems="stretch">
          <Grid item xs={12} md={6} style={{ paddingRight: 16, paddingLeft: 0 }}>
          </Grid>
          <Grid item xs={12} md={6} style={{ paddingRight: 16 }}>
            <LoadingButton
              fullWidth
              variant="contained"
              loading={isGeneratingPost}
              endIcon={<PermMediaIcon />}
              type="submit"
              style={{
                height: '100%',
                whiteSpace: 'nowrap',
                textTransform: 'none',
              }}
              onClick={() => handleFields(true, 'generateimage')}
            >
              Generate Image
            </LoadingButton>
          </Grid>
        </Grid>
      </Stack>
    </>
  );
};

export default ImageGenerationFooterComponent;
